import React from 'react';
import { Table, Tag, Typography } from 'antd';
import { supportTickets } from '../mockData';
import './Support.css';

function Support() {
  const { Title } = Typography;

  const columns = [
    { title: 'Subject', dataIndex: 'subject', key: 'subject' },
    { title: 'Status', dataIndex: 'status', key: 'status', render: (s) => <Tag color={s === 'open' ? 'orange' : 'green'}>{s.toUpperCase()}</Tag> },
    { title: 'Created', dataIndex: 'createdAt', key: 'createdAt' },
    { title: 'Last Update', dataIndex: 'lastUpdate', key: 'lastUpdate' },
  ];

  return (
    <div className="agency-support">
      <Title level={3}>Support</Title>
      <Table rowKey="id" columns={columns} dataSource={supportTickets} pagination={{ pageSize: 5 }} />
    </div>
  );
}

export default Support;
